import request from './request'

export function listWorkers(params) {
  return request.get('/biz/workers', { params })
}
export function saveWorker(data) {
  return request.post('/biz/workers', data)
}
export function deleteWorker(id) {
  return request.delete(`/biz/workers/${id}`)
}
export function getWorkerAccount(id) {
  return request.get(`/biz/workers/${id}/account`)
}
export function saveWorkerAccount(id, data) {
  return request.post(`/biz/workers/${id}/account`, data)
}
export function downloadWorkerImportTemplate() {
  return request.get('/biz/workers/import-template', { responseType: 'blob' })
}
export function importWorkers(file) {
  const fd = new FormData()
  fd.append('file', file)
  return request.post('/biz/workers/import', fd, { timeout: 120000 })
}

export function listWorkerPrices(params) {
  return request.get('/biz/worker-prices', { params })
}
export function listAvailableWorkTypes(excludeId) {
  return request.get('/biz/worker-prices/available-work-types', { params: { excludeId } })
}
export function saveWorkerPrice(data) {
  return request.post('/biz/worker-prices', data)
}
export function deleteWorkerPrice(id) {
  return request.delete(`/biz/worker-prices/${id}`)
}

export function listWorkerPriceItems(params) {
  return request.get('/biz/worker-price-items', { params })
}
export function saveWorkerPriceItem(data) {
  return request.post('/biz/worker-price-items', data)
}
export function deleteWorkerPriceItem(id) {
  return request.delete(`/biz/worker-price-items/${id}`)
}
export function downloadWorkerPriceItemImportTemplate() {
  return request.get('/biz/worker-price-items/import-template', { responseType: 'blob' })
}
export function importWorkerPriceItems(file) {
  const fd = new FormData()
  fd.append('file', file)
  return request.post('/biz/worker-price-items/import', fd, { timeout: 120000 })
}

export function listLaborReqs(params) {
  return request.get('/biz/labor-reqs', { params })
}
export function listLaborReqLineRows(params) {
  return request.get('/biz/labor-reqs/line-rows', { params })
}
export function exportLaborReqLineRows(params) {
  return request.get('/biz/labor-reqs/line-rows/export', { params, responseType: 'blob' })
}
export function listLaborReqProjectLines(projectId) {
  return request.get('/biz/labor-reqs/project-lines', { params: { projectId } })
}
export function listLaborReqProjectLineRows(projectId) {
  return request.get('/biz/labor-reqs/project-line-rows', { params: { projectId } })
}
export function getLaborReq(id) {
  return request.get(`/biz/labor-reqs/${id}`)
}
export function saveLaborReq(data) {
  return request.post('/biz/labor-reqs', data)
}
export function submitLaborReq(id) {
  return request.post(`/biz/labor-reqs/${id}/submit`)
}
export function approveLaborReq(id) {
  return request.post(`/biz/labor-reqs/${id}/approve`)
}
export function unapproveLaborReq(id) {
  return request.post(`/biz/labor-reqs/${id}/unapprove`)
}
export function rejectLaborReq(id, reason) {
  return request.post(`/biz/labor-reqs/${id}/reject`, null, { params: { reason } })
}
export function confirmLaborPay(id, workerId) {
  return request.post(`/biz/labor-reqs/${id}/pay`, null, { params: { workerId } })
}
export function confirmLaborPm(id, workerId) {
  return request.post(`/biz/labor-reqs/${id}/pm-confirm`, null, { params: { workerId } })
}
export function deleteLaborReq(id) {
  return request.delete(`/biz/labor-reqs/${id}`)
}
